/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Delete_Failed_ToastInputs */

const en_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete some terms: ${i?.message}`)
};

const fr_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la suppression de certains termes : ${i?.message}`)
};

const de_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einige Begriffe konnten nicht gelöscht werden: ${i?.message}`)
};

const it_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare alcuni termini: ${i?.message}`)
};

const ru_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить некоторые термины: ${i?.message}`)
};

const es_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron eliminar algunos términos: ${i?.message}`)
};

const zh_cn2_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除某些术语失败：${i?.message}`)
};

const ja_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`いくつかの用語を削除できませんでした: ${i?.message}`)
};

const hi_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुछ शब्दों को हटाने में विफलता: ${i?.message}`)
};

const pt_pt2_knp_lookup_delete_failed_toast = /** @type {(inputs: Knp_Lookup_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível excluir alguns termos: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to delete some terms: {message}" |
*
* @param {Knp_Lookup_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_failed_toast = /** @type {((inputs: Knp_Lookup_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_delete_failed_toast(inputs)
	if (locale === "de") return de_knp_lookup_delete_failed_toast(inputs)
	if (locale === "it") return it_knp_lookup_delete_failed_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_delete_failed_toast(inputs)
	if (locale === "es") return es_knp_lookup_delete_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_delete_failed_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_delete_failed_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_delete_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_delete_failed_toast(inputs)
	return en_knp_lookup_delete_failed_toast(inputs)
});